import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=24739d05&scoped=true&"
import script from "./PaymentDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=24739d05&lang=scss&scoped=true&"
import style1 from "./PaymentDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24739d05",
  null
  
)

export default component.exports